export default "__VITE_ASSET__UwFTX$J$__"